import React from 'react';
import { Link } from 'react-router-dom';
import { industries } from '../mockData';
import { Button } from '../components/ui/button';

const Industries = () => {
  const allIndustries = [
    ...industries,
    {
      id: 7,
      name: 'Traffic Control',
      image: 'https://images.unsplash.com/photo-1613314188851-2c04697535ab?w=1200&q=80',
      description: 'Qualified traffic controllers and site management teams'
    },
    {
      id: 8,
      name: 'Events & Property Services',
      image: 'https://images.unsplash.com/photo-1641122669951-3e2aff778d3b?w=1200&q=80',
      description: 'Event staff, property management, and strata services'
    }
  ];

  return (
    <div style={{ backgroundColor: '#1a1c1b', minHeight: '100vh' }}>
      {/* Hero Section */}
      <section style={{
        padding: '120px 40px 80px',
        backgroundColor: '#302f2c',
        borderBottom: '1px solid rgba(63, 72, 22, 0.5)'
      }}>
        <div style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <h1 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(2.5rem, 5vw, 4rem)',
            lineHeight: 0.95,
            color: '#d9fb06',
            textTransform: 'uppercase',
            marginBottom: '24px'
          }}>
            Industries We Serve
          </h1>
          <p style={{
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: '1.25rem',
            lineHeight: 1.6,
            color: '#dfddd6',
            maxWidth: '50rem',
            margin: '0 auto'
          }}>
            Delivering workforce excellence across diverse Australian industries
          </p>
        </div>
      </section>

      {/* Industries Grid */}
      <section style={{
        padding: '96px 40px',
        backgroundColor: '#1a1c1b'
      }}>
        <div style={{
          maxWidth: '87.5rem',
          margin: '0 auto'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '32px'
          }}>
            {allIndustries.map((industry) => (
              <div
                key={industry.id}
                style={{
                  backgroundColor: '#302f2c',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  cursor: 'pointer',
                  border: '1px solid rgba(63, 72, 22, 0.5)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(217, 251, 6, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{
                  height: '280px',
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                  <img
                    src={industry.image}
                    alt={industry.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                    padding: '40px 24px 20px'
                  }}>
                    <h3 style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 700,
                      fontSize: '1.4rem',
                      color: '#d9fb06',
                      marginBottom: '0',
                      textTransform: 'uppercase'
                    }}>
                      {industry.name}
                    </h3>
                  </div>
                </div>
                <div style={{ padding: '24px' }}>
                  <p style={{
                    fontFamily: 'Inter, Arial, sans-serif',
                    fontSize: '1rem',
                    color: '#dfddd6',
                    lineHeight: 1.6,
                    marginBottom: '0'
                  }}>
                    {industry.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industry Expertise */}
      <section style={{
        padding: '96px 40px',
        backgroundColor: '#302f2c'
      }}>
        <div style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <h2 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            lineHeight: 1.1,
            color: '#d9fb06',
            textTransform: 'uppercase',
            marginBottom: '32px'
          }}>
            Cross-Industry Excellence
          </h2>
          <p style={{
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: '1.25rem',
            lineHeight: 1.6,
            color: '#dfddd6',
            maxWidth: '60rem',
            margin: '0 auto 48px'
          }}>
            Our multi-supplier network enables us to deliver skilled workforce solutions across all major Australian industries with consistent quality, compliance, and reliability.
          </p>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '24px',
            textAlign: 'left'
          }}>
            {[
              'Tier 1, Tier 2 & government-ready',
              'Strict compliance screening',
              'Industry-specific expertise',
              'Rapid workforce mobilisation',
              'Backup labour guarantees',
              'Quality performance monitoring'
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: '#1a1c1b',
                  padding: '24px',
                  borderRadius: '8px',
                  border: '1px solid rgba(63, 72, 22, 0.5)',
                  transition: 'background-color 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#3f4816'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1a1c1b'}
              >
                <p style={{
                  fontFamily: 'Inter, Arial, sans-serif',
                  fontSize: '1rem',
                  color: '#dfddd6',
                  margin: 0
                }}>
                  • {item}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: '96px 40px',
        backgroundColor: '#3f4816',
        textAlign: 'center'
      }}>
        <div style={{
          maxWidth: '60rem',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            lineHeight: 1.1,
            color: '#d9fb06',
            marginBottom: '24px',
            textTransform: 'uppercase'
          }}>
            Find Your Industry Solution
          </h2>
          <p style={{
            fontFamily: 'Inter, Arial, sans-serif',
            fontSize: '1.25rem',
            lineHeight: 1.6,
            color: '#dfddd6',
            marginBottom: '40px'
          }}>
            Contact us to discuss your specific industry workforce needs
          </p>
          <div style={{
            display: 'flex',
            gap: '16px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Link to="/contact?form=workforce" style={{ textDecoration: 'none' }}>
              <Button
                style={{
                  background: '#d9fb06',
                  color: '#1a1c1b',
                  border: 'none',
                  borderRadius: '10rem',
                  padding: '1.2em 2em',
                  fontFamily: 'Inter, Arial, sans-serif',
                  fontWeight: 600,
                  fontSize: '1rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  textTransform: 'uppercase'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                Request Workforce
              </Button>
            </Link>
            <Link to="/services" style={{ textDecoration: 'none' }}>
              <Button
                style={{
                  background: 'transparent',
                  color: '#d9fb06',
                  border: '2px solid #d9fb06',
                  borderRadius: '10rem',
                  padding: '1.2em 2em',
                  fontFamily: 'Inter, Arial, sans-serif',
                  fontWeight: 600,
                  fontSize: '1rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  textTransform: 'uppercase'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#d9fb06';
                  e.currentTarget.style.color = '#1a1c1b';
                  e.currentTarget.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#d9fb06';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                View Services
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;
